import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { Modal } from 'antd'
import { setApiIntercept, config } from 'zn-common'

import App from './app/App'
import routes from './routes'

import '@toast-ui/editor/dist/toastui-editor.css'
import 'zn-admin-style'
import 'zn-admin-ui/lib/styles/index.css'
import 'zn-admin-style/micro-app-dev/index.less'

import './styles/index.less'


config.set('const.API', '/open/znClientapi/')

let hasConfirmPopup = false

const confirmPromise = () => new Promise((res) => {
  hasConfirmPopup = true
  Modal.confirm({
    content: '此功能需要登录',
    okText: '去登录',
    cancelText: '取消',
    onOk: () => {
      hasConfirmPopup = false
      res(true)
    },
    onCancel: () => {
      hasConfirmPopup = false
      res(false)
    }
  })
})

setApiIntercept(async (res) => {
  if (res && +res.code === 402 && !window.location.href.includes('#/login')) {
    if (!hasConfirmPopup) {
      const goLogin = await confirmPromise()
      if (goLogin) {
        window.location.href = `${process.env.PUBLIC_URL}#/login?back=${window.location.hash.substr(1)}`
      }
    }
    return ({ _failure: true })
  }
  return null
})

ReactDOM.render(
  <App routes={routes} />,
  document.getElementById('root')
)